export default __webpack_public_path__ + "static/media/sandero-small.6555a581.jpg";